import Box from '@mui/material/Box'
import { Button, Stack, Typography } from '@mui/material'
import EngineersListItemComponent from '../components/Engineering/EngineersListItemComponent'

function Team() {
  const engineers: {
    name: string
    location: string
    phoneNumber: string
    email: string
    projects: string[]
  }[] = [
    {
      name: 'Peter Smith',
      location: 'Seattle, WA',
      phoneNumber: '555-555-5555',
      email: 'peter.vl@connectedengineering.com',
      projects: [
        '1993 Example Ave.',
        '29913 Example St.',
        '8848 Example Ln.',
        '412 Example Ave.',
        '1993 Example Ave.',
        '29913 Example St.',
        '8848 Example Ln.',
        '412 Example Ave.',
        '1993 Example Ave.',
        '29913 Example St.',
        '8848 Example Ln.',
        '412 Example Ave.',
      ],
    },
    {
      name: 'Peter Smith',
      location: 'Seattle, WA',
      phoneNumber: '555-555-5555',
      email: 'peter.vl@connectedengineering.com',
      projects: [],
    },
    {
      name: 'Peter Smith',
      location: 'Seattle, WA',
      phoneNumber: '555-555-5555',
      email: 'peter.vl@connectedengineering.com',
      projects: [],
    },
    {
      name: 'Peter Smith',
      location: 'Seattle, WA',
      phoneNumber: '555-555-5555',
      email: 'peter.vl@connectedengineering.com',
      projects: [],
    },
    {
      name: 'Peter Smith',
      location: 'Seattle, WA',
      phoneNumber: '555-555-5555',
      email: 'peter.vl@connectedengineering.com',
      projects: [],
    },
    {
      name: 'Peter Smith',
      location: 'Seattle, WA',
      phoneNumber: '555-555-5555',
      email: 'peter.vl@connectedengineering.com',
      projects: [],
    },
    {
      name: 'Peter Smith',
      location: 'Seattle, WA',
      phoneNumber: '555-555-5555',
      email: 'peter.vl@connectedengineering.com',
      projects: [],
    },
    {
      name: 'Peter Smith',
      location: 'Seattle, WA',
      phoneNumber: '555-555-5555',
      email: 'peter.vl@connectedengineering.com',
      projects: [],
    },
    {
      name: 'Peter Smith',
      location: 'Seattle, WA',
      phoneNumber: '555-555-5555',
      email: 'peter.vl@connectedengineering.com',
      projects: [],
    },
    {
      name: 'Peter Smith',
      location: 'Seattle, WA',
      phoneNumber: '555-555-5555',
      email: 'peter.vl@connectedengineering.com',
      projects: [],
    },
  ]

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Box display='flex' justifyContent='space-between'>
        <Typography
          sx={{
            color: '#06004A',
            fontSize: '0.94rem',
            fontWeight: 500,
            lineHeight: 'normal',
          }}
        >
          Engineering Team
        </Typography>
        <Button
          disableRipple
          variant='text'
          sx={{
            color: '#06004A',
            fontSize: '0.76rem',
            fontWeight: 500,
            lineHeight: 'normal',
            textTransform: 'capitalize',
          }}
        >
          View All
        </Button>
      </Box>
      <Stack>
        {engineers.map((engineer, index) => (
          <Box
            key={index}
            display='flex'
            width='100%'
            borderRadius='6px'
            boxSizing='border-box'
            boxShadow='0px 2px 10px 0px #0000001A'
            padding='1rem'
          >
            <EngineersListItemComponent engineer={engineer} />
          </Box>
        ))}
      </Stack>
    </Box>
  )
}

export default Team
